<template>
  <div class="row discount-campaigns">
    <div class="col-xl-12 col-md-12 col-xs-12">
      <div class="card mar-to-15 tableInvoice">
        <div class="card-content">

          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg>
            </div>
          </div>

          <div class="table-top" style="display: flex; justify-content: space-between; align-items: flex-start; gap: 10px; flex-wrap: wrap;">
            <div class="left-group" style="display: flex; flex-wrap: wrap; gap: 8px; align-items: flex-end; flex: 1 1 auto;">
              <div class="form-group" style="flex: 1 1 200px; margin: 0;">
                <label>{{ $t('discountCampaigns.search') }}</label>
                <el-input
                  v-model="search"
                  :placeholder="$t('discountCampaigns.search')"
                  size="small"
                  clearable
                  @input="onInput"
                />
              </div>
              <div class="form-group" style="flex: 0 0 100px; margin: 0;">
                <button class="btn add" @click="applyFilters" style="width: 100%; font-size: 12px; padding: 4px 8px;">
                  <i class="ti-search"></i> {{ $t('general.search') }}
                </button>
              </div>
            </div>
            <div class="right-group" style="flex: 0 0 auto; margin-bottom: 20px;">
              <button class="btn add" @click.prevent="goToAdd" style="font-size: 12px; padding: 4px 8px;">
                <img src="/static/img/icons/icon-plus-sm.png" /> {{ $t('general.add') }} {{ $t('discountCampaigns.single') }}
              </button>
            </div>
          </div>

          <div class="data-table" style="margin-top: 20px;">
            <el-table
              :data="tableData"
              :row-class-name="rowClass"
              :empty-text="$t('gestiune.noData')"
              style="width: 100%;"
              @row-click="onRowClick">
              <el-table-column prop="id" :label="$t('discountCampaigns.id')" width="70"/>
              <el-table-column prop="name" :label="$t('discountCampaigns.name')" min-width="140"/>
              <el-table-column :label="$t('discountCampaigns.discount')" width="120">
                <template slot-scope="props">
                  {{ formatDiscount(props.row) }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('discountCampaigns.priceProfile')" min-width="130">
                <template slot-scope="props">
                  {{ priceProfileName(props.row) }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('discountCampaigns.sourceMethodCombos')" min-width="200">
                <template slot-scope="props">
                  <div v-if="props.row.combosList.full.length" class="truncated-cell">
                    <span class="truncated-cell__text">{{ props.row.combosList.visible.join(', ') }}</span>
                    <el-tooltip
                      v-if="props.row.combosList.restCount"
                      placement="top"
                      effect="dark"
                      :open-delay="200">
                      <div slot="content" class="truncated-cell__tooltip">
                        <div v-for="(label, index) in props.row.combosList.full" :key="index">{{ label }}</div>
                      </div>
                      <span class="truncated-cell__more">+{{ props.row.combosList.restCount }}</span>
                    </el-tooltip>
                  </div>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('discountCampaigns.startEnd')" min-width="170">
                <template slot-scope="props">
                  {{ formatDate(props.row.start_date) }} - {{ formatDate(props.row.end_date) }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('discountCampaigns.products')" min-width="200">
                <template slot-scope="props">
                  <div v-if="props.row.productsList.full.length" class="truncated-cell">
                    <span class="truncated-cell__text">{{ props.row.productsList.visible.join(', ') }}</span>
                    <el-tooltip
                      v-if="props.row.productsList.restCount"
                      placement="top"
                      effect="dark"
                      :open-delay="200">
                      <div slot="content" class="truncated-cell__tooltip">
                        <div v-for="(label, index) in props.row.productsList.full" :key="index">{{ label }}</div>
                      </div>
                      <span class="truncated-cell__more">+{{ props.row.productsList.restCount }}</span>
                    </el-tooltip>
                  </div>
                  <span v-else>{{ productsCountFallback(props.row) }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('general.active')" width="90">
                <template slot-scope="scope">
                  <div @click.stop>
                    <p-switch
                      v-model="scope.row.active"
                      type="success"
                      @input="handleActive(scope.$index, scope.row, $event)"
                    />
                  </div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('general.actions')" width="100">
                <template slot-scope="scope">
                  <el-dropdown trigger="click" placement="bottom-end" @click.native.stop>
                    <span class="arrow-box">&#9662;</span>
                    <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">
                      <el-dropdown-item @click.native.stop="goToRecord(scope.row)">
                        {{ $t('general.edit') }}
                      </el-dropdown-item>
                      <el-dropdown-item @click.native.stop="handleDelete(scope.$index, scope.row)">
                        {{ $t('general.delete') }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination
              layout="prev, pager, next"
              :total="paginationDef.totalRecords"
              :page-size="paginationDef.perPage"
              :current-page.sync="paginationDef.page"
              @current-change="handlePageChange"
              style="margin-top: 15px; text-align: right;"
            />
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import PSwitch from 'src/components/UIComponents/Switch.vue'
import swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.css'
import { Tooltip } from 'element-ui'
import {
  formatTruncatedList,
  getComboLabels,
  getProductLabels
} from './discountCampaignConstants'

Vue.use(Tooltip)

const VISIBLE_LIST_ITEMS = 2

export default {
  components: {
    PSwitch
  },
  props: {
    isDiscountCampaigns: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: true,
      onInputTimeout: null,
      search: '',
      tableData: [],
      paginationDef: {
        page: 1,
        perPage: 20,
        totalPages: null,
        totalRecords: null
      }
    }
  },
  created () {
    this.getCampaigns()
    this.$bus.$on('refresh', this.handleRefresh)
  },
  beforeDestroy () {
    this.$bus.$off('refresh', this.handleRefresh)
  },
  methods: {
    priceProfileName (row) {
      if (row.price_profile && row.price_profile.name) {
        return row.price_profile.name
      }
      return row.price_profile_name || row.price_profile_id || '-'
    },
    productsCountFallback (row) {
      if (row.lines_count != null) return row.lines_count
      if (row.products_count != null) return row.products_count
      return '-'
    },
    handleRefresh () {
      this.getCampaigns()
    },
    onRowClick (row, column, event) {
      if (event.target.closest('.el-switch') || event.target.closest('.el-dropdown')) {
        return
      }
      this.goToRecord(row)
    },
    goToAdd () {
      this.$router.push({ path: '/marketing/discount-campaigns/add' })
    },
    goToRecord (row) {
      this.$router.push({ path: '/marketing/discount-campaigns/edit/' + row.id })
    },
    applyFilters () {
      this.paginationDef.page = 1
      this.getCampaigns()
    },
    onInput () {
      clearTimeout(this.onInputTimeout)
      this.onInputTimeout = setTimeout(() => {
        this.paginationDef.page = 1
        this.getCampaigns()
      }, 500)
    },
    handlePageChange (page) {
      this.paginationDef.page = page
      this.getCampaigns()
    },
    buildParams () {
      const params = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        page: this.paginationDef.page,
        perPage: this.paginationDef.perPage
      }
      if (this.search) {
        params.name = this.search
      }
      return params
    },
    getCampaigns () {
      this.loading = true
      this.apiRequest('/discount-campaigns', 'GET', this.buildParams(), (response) => {
        if (response.status === true) {
          const rows = Array.isArray(response.data) ? response.data : (response.data && response.data.data) || []
          this.tableData = rows.map(row => ({
            ...row,
            active: !!(parseInt(row.active, 10) === 1 || row.active === true),
            productsList: formatTruncatedList(getProductLabels(row), null, VISIBLE_LIST_ITEMS),
            combosList: formatTruncatedList(getComboLabels(row), null, VISIBLE_LIST_ITEMS)
          }))
          if (response.pagination) {
            this.paginationDef.page = response.pagination.page
            this.paginationDef.perPage = response.pagination.perPage
            this.paginationDef.totalPages = response.pagination.totalPages
            this.paginationDef.totalRecords = response.pagination.totalRecords
          } else if (response.data && response.data.pagination) {
            this.paginationDef.page = response.data.pagination.page
            this.paginationDef.perPage = response.data.pagination.perPage
            this.paginationDef.totalPages = response.data.pagination.totalPages
            this.paginationDef.totalRecords = response.data.pagination.totalRecords
          } else {
            this.paginationDef.totalRecords = this.tableData.length
          }
        }
        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    formatDiscount (row) {
      const discount = parseFloat(row.discount || 0)
      if (parseInt(row.discount_type, 10) === 2) {
        return discount + '%'
      }
      return this.formatMoneyAmount(discount)
    },
    rowClass ({ row }) {
      return row.active ? 'highlight-row' : ''
    },
    handleActive (index, row, e) {
      const actionText = row.active ? this.$t('general.activate') : this.$t('general.deactivate')
      swal({
        text: this.$t('validations.areYouSureYouWantTo') + ` ${actionText} ${row.name}?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then((result) => {
        if (result) {
          const data = {
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany'),
            active: row.active ? 1 : 0
          }
          this.apiRequest('/discount-campaigns/' + row.id, 'PUT', data, (response) => {
            if (response.status) {
              swal(this.$t('general.success') + '!', '', 'success').catch(() => {})
            } else {
              swal('', this.$t('validations.wentWrong'), 'error').catch(() => {})
              row.active = !row.active
            }
          })
        }
      }).catch(() => {
        row.active = !row.active
      })
    },
    handleDelete (index, row) {
      swal({
        text: this.$t('discountCampaigns.areYouSureDelete') + ' ' + row.name + '?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then((result) => {
        if (result) {
          const data = {
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany')
          }
          this.apiRequest('/discount-campaigns/' + row.id, 'DELETE', data, (response) => {
            if (response.status === true) {
              swal('', this.$t('discountCampaigns.campaignDeleted'), 'success').catch(() => {})
              this.tableData.splice(index, 1)
            } else {
              swal('', this.$t('validations.wentWrong'), 'error').catch(() => {})
            }
          })
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped lang="scss">
.discount-campaigns .form-group {
  margin-bottom: 15px;
}
.arrow-box {
  display: inline-block;
  font-size: 18px;
  padding: 4px 6px;
  border: 1px solid #674BD2 !important;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  user-select: none;
  color: #674BD2;
}
.arrow-box:hover {
  background-color: #674BD2 !important;
  color: #fff !important;
}
.custom-dropdown-menu {
  min-width: 180px;
  font-size: 14px;
}
.el-pagination {
  text-align: center !important;
}
.truncated-cell {
  align-items: center;
  cursor: default;
  display: inline-flex;
  max-width: 100%;
  overflow: hidden;
}
.truncated-cell__text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.truncated-cell__more {
  background: #674BD2;
  border-radius: 10px;
  color: #fff;
  flex: 0 0 auto;
  font-size: 11px;
  line-height: 1;
  margin-left: 6px;
  padding: 3px 6px;
}
.truncated-cell__tooltip div + div {
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/DiscountCampaigns/DiscountCampaigns.vue